import { connect } from 'react-redux';

import { 
    fetchItemsUsersPanel, 
    incrementUsersOffset, 
    changeUsersPage, 
    nonIncrementUsersOffset,
    resetUsersOffset
} from '../../../actions/AdminPanel';

import UsersPanel from '../../../components/AdminPanel/UsersPanel/UsersPanel'
import { openDialog } from '../../../actions/Dialog';
import DialogShowUserData from '../../DialogShowUserDataWrapper/DialogShowUserDataWrapper';

const mapStateToProps = (state) => {
    const isLoggedIn = !!state.currentAccount.spaId;
    return ({
        isLoggedIn: isLoggedIn,
        spaId: state.currentAccount.spaId,
        spaUsername: state.currentAccount.spaUsername,

        data: state.adminPanel.data,

        isFetching: state.adminPanel.isFetching,
        isError: state.adminPanel.isError,
        filtered: state.adminPanel.filtered,
    })
}

const mapDispatchToProps = (dispatch) => ({
    onGetUserData: (userId) => {
        dispatch(openDialog(<DialogShowUserData ownerId={userId} />))
    },

    fetchItemsUsersPanel: (username) => {
        dispatch(resetUsersOffset())
        dispatch(fetchItemsUsersPanel(username))
    },
    onChangeUsersPage: (page) => {
        Promise.resolve(
            dispatch(changeUsersPage(page))
        ).then(() => {
            dispatch(incrementUsersOffset())
            dispatch(fetchItemsUsersPanel(document.location.hash.slice(14), false))})
    },
    onChangeUsersPrevPage: (page) => {
        Promise.resolve(
            dispatch(changeUsersPage(page))
        ).then(() => {
            dispatch(nonIncrementUsersOffset())
            dispatch(fetchItemsUsersPanel(document.location.hash.slice(14), false))})
    },
    onIncrementDownloadCount: () => {
        //
    },
    onPublished: () => {
        //
    },
    onRejected: () => {
        //
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersPanel)
